/**
 * ------------------------------------------------------------
 * Developer Name : Praveen Tripathi
 * Purpose        : Shared MBA LP phone CTA header resolution
 * ------------------------------------------------------------
 */

import { pushToDataLayer } from "@/helpers/gtag";
import {
  AI_Phone_Slug,
  second_Phone_Slug,
} from "@/components/LandingPageMBA/MbaLandingPageHeader/utils";

export type MbaPhoneHeaderResult = {
  updatedheader: any;
  isPhoneNumber: boolean;
};

export function resolveMbaPhoneHeader(
  header: any,
  slug: string,
): MbaPhoneHeaderResult {
  const AI_Phone = AI_Phone_Slug.includes(slug);
  const second_Phone = second_Phone_Slug.includes(slug);
  const isPhoneNumber = AI_Phone || second_Phone;

  if (!header) {
    return { updatedheader: header, isPhoneNumber };
  }

  if (AI_Phone) {
    return {
      isPhoneNumber,
      updatedheader: {
        ...header,
        CTA: {
          ...header?.CTA,
          text: "+91-9240038562",
          href: "tel:+919240038562",
          gaEvents: () => {
            pushToDataLayer({
              event: "call_now_clicked",
              cta_text: "Call Now",
              page_type: "Campaign Page",
              section_name: "Header",
              page_url: window.location.href,
            });
          },
        },
      },
    };
  }

  if (second_Phone) {
    return {
      isPhoneNumber,
      updatedheader: {
        ...header,
        CTA: {
          ...header?.CTA,
          text: "+91-9711619073",
          href: "tel:+91-9711619073",
          gaEvents: () => {
            pushToDataLayer({
              event: "call_now_clicked",
              cta_text: "Call Now",
              page_type: "Campaign Page",
              section_name: "Header",
              page_url: window.location.href,
            });
          },
        },
      },
    };
  }

  return { updatedheader: header, isPhoneNumber };
}
